import React, { useEffect, useState } from "react"
import { useAsyncDebounce } from "react-table"

// @ts-ignore
export const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter)
  useEffect(() => {
    setValue(filter)
  }, [filter])
  const onChange = useAsyncDebounce((value) => {
    console.log("inside global filter value", value)
    localStorage.setItem("globalFilterBed", value)
    setFilter(value || undefined)
  }, 1000)
  return (
    <div className="col-12">
      <input
        className="inputGlobalSearch"
        placeholder="Search"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value)
          onChange(e.target.value)
        }}
      />
      {/* <img
        src="assets/images/searchIcon.svg"
        alt=""
        style={{ marginLeft: "-50px", width: "26px", height: "26px" }}
      /> */}
    </div>
  )
}
